// src/utils/devLog.js
// Shared development-only logging utility
export function devLog(...args) {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
}
